import { IBillingAdminRepository } from "../../adapters/driven/repositories/billingAdminRepository";

export const BillingAdminServiceImplFactory = ({
  billingAdminRepository,
}: {
  billingAdminRepository: IBillingAdminRepository;
}) => {
  /**
   * Payers
   */
  const getPayers: IGetPayersService = async (payload) => {
    try {
      const response = await billingAdminRepository.GetPayers(payload);
      return {
        success: response.success || !!response.data,
        ...response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const updatePayer: IUpdateBillingAdminPayer = async (payload) => {
    try {
      const response = await billingAdminRepository.UpdatePayer(payload);
      return {
        success: !!response.data,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const createPayer: ICreateBillingAdminPayer = async (payload) => {
    try {
      const response = await billingAdminRepository.CreatePayer(payload);
      return {
        success: !!response.data,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const deletePayer: IDeleteBillingAdminPayer = async (id) => {
    try {
      const response = await billingAdminRepository.DeletePayer(id);
      return {
        success: !!response.success,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  /***********************************************************
   * Providers
   ***********************************************************/

  const getProviders: IGetProvidersService = async (payload) => {
    try {
      const response = await billingAdminRepository.GetProviders(payload);
      return {
        success: !!response.data,
        ...response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const updateProvider: IUpdateBillingAdminProvider = async (payload) => {
    try {
      const response = await billingAdminRepository.UpdateProvider(payload);
      return {
        success: !!response.data,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const createProvider: ICreateBillingAdminProvider = async (payload) => {
    try {
      const response = await billingAdminRepository.CreateProvider(payload);
      return {
        success: !!response.data,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const deleteProvider: IDeleteBillingAdminProvider = async (id) => {
    try {
      const response = await billingAdminRepository.DeleteProvider(id);
      return {
        success: !!response.success,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  /***********************************************************
   * Entity
   ***********************************************************/
  const getEntities: IGetEntityService = async (payload) => {
    try {
      const response = await billingAdminRepository.GetEntities(payload);
      return {
        success: !!response.data,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const updateEntity: IUpdateBillingAdminEntity = async (payload) => {
    try {
      const response = await billingAdminRepository.UpdateEntity(payload);
      return {
        success: !!response.data,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const createEntity: ICreateBillingAdminEntity = async (payload) => {
    try {
      const response = await billingAdminRepository.CreateEntity(payload);
      return {
        success: !!response.data,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const deleteEntity: IDeleteBillingAdminEntity = async (id) => {
    try {
      const response = await billingAdminRepository.DeleteEntity(id);
      return {
        success: !!response.success,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  /***********************************************************
   * Clinics
   ***********************************************************/
  const getClinics: IGetBillingAdminClinics = async (payload) => {
    try {
      const response = await billingAdminRepository.GetClinics(payload);
      return {
        success: response.success || !!response.data,
        ...response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const updateClinic: IUpdateBillingAdminClinic = async (payload) => {
    try {
      const response = await billingAdminRepository.UpdateClinic(payload);
      return {
        success: !!response.data,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  /***********************************************************
   * Rosters
   ***********************************************************/
  const getRosters: IGetRosterService = async (payload) => {
    try {
      const response = await billingAdminRepository.GetRosters(payload);
      return {
        success: !!response.data,
        ...response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };
  const updateRoster: IUpdateBillingAdminRoster = async (payload) => {
    try {
      const response = await billingAdminRepository.UpdateRoster(payload);
      return {
        success: !!response.data,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const createRoster: ICreateBillingAdminRoster = async (payload) => {
    try {
      const response = await billingAdminRepository.CreateRoster(payload);
      return {
        success: !!response.data,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const deleteRoster: IDeleteBillingAdminRoster = async (id) => {
    try {
      const response = await billingAdminRepository.DeleteRoster(id);
      return {
        success: !!response.success,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  /***********************************************************
   * Patients
   ***********************************************************/
  const getPatients: IGetPatientsService = async (payload) => {
    try {
      const response = await billingAdminRepository.GetPatients(payload);
      return {
        success: !!response.data,
        ...response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const updatePatient: IUpdateBillingAdminPatient = async (payload) => {
    try {
      const response = await billingAdminRepository.UpdatePatient(payload);
      return {
        success: !!response.data,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const createPatient: ICreateBillingAdminPatient = async (payload) => {
    try {
      const response = await billingAdminRepository.CreatePatient(payload);
      return {
        success: !!response.data,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const deletePatient: IDeleteBillingAdminPatient = async (id) => {
    try {
      const response = await billingAdminRepository.DeletePatient(id);
      return {
        success: !!response.success,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  // Charges
  const getCharges: IGetBillingAdminCharges = async (payload) => {
    try {
      const response = await billingAdminRepository.GetCharges(payload);
      return {
        success: !!response.data,
        ...response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const updateCharges: IUpdateBillingAdminCharges = async (payload) => {
    try {
      const response = await billingAdminRepository.UpdateCharges(payload);
      return {
        success: !!response.data,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const createCharges: ICreateBillingAdminCharges = async (payload) => {
    try {
      const response = await billingAdminRepository.CreateCharges(payload);
      return {
        success: !!response.data,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const deleteCharges: IDeleteBillingAdminCharges = async (id) => {
    try {
      const response = await billingAdminRepository.DeleteCharges(id);
      return {
        success: !!response.success,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const getChargesStatusSummary = async (payload: any) => {
    try {
      const response = await billingAdminRepository.GetChargesStatusSummary(
        payload
      );
      return {
        success: response.success || !!response.data,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const checkPatientEligibility: ICheckPatientEligibility = async (payload) => {
    try {
      const data = await billingAdminRepository.GetEligibility(payload);
      const isErrorResponse =
        data != null && typeof data === "object" && "detail" in data;
      return { success: !isErrorResponse, data };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const refreshEligibility: IRefreshEligibilityController = async (payload) => {
    try {
      const data = await billingAdminRepository.RefreshEligibility(payload);
      const isErrorResponse =
        data != null && typeof data === "object" && "detail" in data;

      if (isErrorResponse) {
        return { success: false, error: data };
      }

      return { success: true, data };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  return {
    getPayers,
    updatePayer,
    createPayer,
    deletePayer,

    getProviders,
    updateProvider,
    createProvider,
    deleteProvider,

    getEntities,
    updateEntity,
    createEntity,
    deleteEntity,

    getClinics,
    updateClinic,

    getRosters,
    updateRoster,
    createRoster,
    deleteRoster,

    getPatients,
    updatePatient,
    createPatient,
    deletePatient,

    getCharges,
    updateCharges,
    createCharges,
    deleteCharges,
    getChargesStatusSummary,
    checkPatientEligibility,
    refreshEligibility,
  };
};
